"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function () { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function (o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function (o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function (o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o)
                if (Object.prototype.hasOwnProperty.call(o, k))
                    ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule)
            return mod;
        var result = {};
        if (mod != null)
            for (var k = ownKeys(mod), i = 0; i < k.length; i++)
                if (k[i] !== "default")
                    __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductEditorTableRow = void 0;
const react_1 = __importStar(require("react"));
const ui_components_1 = require("@groupby/ui-components");
const material_1 = require("@mui/material");
const classnames_1 = __importDefault(require("classnames"));
const row_styles_1 = require("./row.styles");
const hooks_1 = require("../../../hooks");
const ProductEditorTableRow = ({ getTableRows, isRowChecked, onRowSelect, product, shouldRowBeHighlighted, isExpandable, }) => {
    const [isExpanded, setIsExpanded] = (0, react_1.useState)(false);
    const row = (0, react_1.useRef)(null);
    (0, hooks_1.useRowHighlighting)({
        targetRef: row,
        shouldRowBeHighlighted,
        value: product,
        className: 'row--highlighted',
    });
    const rows = (0, react_1.useMemo)(() => getTableRows(product, { isExpanded }), [getTableRows, isExpanded, product]);
    const handleToggleCollapse = () => setIsExpanded((expanded) => !expanded);
    return (react_1.default.createElement(row_styles_1.StyledRow, { ref: row, className: (0, classnames_1.default)({ 'row--checked': isRowChecked, 'row--expanded': isExpanded }) }, isExpandable && (react_1.default.createElement(row_styles_1.StyledCollapseCell, { key: "collapsed", size: "small", align: "left", className: 'row-expand-cell', onClick: handleToggleCollapse }, react_1.default.createElement(material_1.IconButton, { disableRipple: true, size: "small" }, react_1.default.createElement(ui_components_1.Icon, { variant: isExpanded ? 'chevronDown' : 'chevronRight', color: ui_components_1.baseColors.primaryGreen300 })))), react_1.default.createElement(row_styles_1.StyledTableCell, { key: "checkbox", size: "small", align: "left" }, react_1.default.createElement(ui_components_1.Checkbox, { disableRipple: true, checked: isRowChecked, handleChange: (event) => onRowSelect(event, product) })), rows));
};
exports.ProductEditorTableRow = ProductEditorTableRow;
exports.default = exports.ProductEditorTableRow;
